import { useState, useEffect, useRef } from 'react';

function useScript(src: any) {
  const [state, setState] = useState<any>({
    value: 'loading',
    payload: undefined,
  }); // value { loading | loaded | error }
  const script = useRef<any>();

  useEffect(() => {
    script.current = document.createElement('script');
    script.current.src = src;
    script.current.async = true;

    const onScriptLoad = () => setState({ value: 'loaded' });

    const onScriptError = (e: any) => {
      script.current.remove();
      setState({ value: 'error', payload: e });
    };

    script.current.addEventListener('load', onScriptLoad);
    script.current.addEventListener('error', onScriptError);

    document.body.appendChild(script.current);
    return () => {
      script.current.removeEventListener('load', onScriptLoad);
      script.current.removeEventListener('error', onScriptError);
    };
  }, [src]);

  return state;
}

export default useScript;
